import { Controller } from '@hotwired/stimulus'
import { getUserConfirmation } from '~/utils/confirmation_dialog'
import { lock as disableBodyScroll, unlock as enableBodyScroll } from 'tua-body-scroll-lock'
import { useEventListener } from '~/controllers/concerns/use_event_listener'

export default class extends Controller {
  static targets = ['container', 'background']

  static values = {
    mouseDownOnContainer: Boolean,
    requireConfirmation: Boolean,
    backgroundPageId: String,
    backlink: String,
    redirectWhenClosed: Boolean
  }

  connect() {
    useEventListener(this, {
      element: document.documentElement,
      event: 'turbo:before-stream-render',
      listener: 'beforeTurboStreamRender'
    })
    disableBodyScroll(this.element)
  }

  disconnect() {
    this.removeModal()
  }

  close(e) {
    e.preventDefault()

    if (this.requireConfirmationValue === true) {
      getUserConfirmation().then(userConfirmed => {
        if (userConfirmed) {
          this.removeModal()
        }
      })
    } else {
      this.removeModal()
    }
  }

  removeModal() {
    if (this.hasBackgroundPageIdValue && this.hasBacklinkValue) {
      const originPageIsBehindLightbox = document.getElementById(this.backgroundPageIdValue)
      if (originPageIsBehindLightbox) {
        this.closeModal()
        this.replaceUrl()
      } else {
        this.redirectToBacklink()
      }
    } else if (this.redirectWhenClosedValue) {
      this.redirectToBacklink()
    } else {
      this.closeModal()
    }
  }

  replaceUrl() {
    window.history.pushState({}, null, this.backlinkValue)
  }

  redirectToBacklink() {
    window.location.replace(this.backlinkValue)
  }

  closeModal() {
    if (this.hasBackgroundTarget) {
      this.backgroundTarget.classList.add(this.toggleClass)
    }

    enableBodyScroll(this.element)
    this.element.remove()
  }

  mousedownOnContainer(e) {
    this.mouseDownOnContainerValue = e.target === this.containerTarget
  }

  closeBackground(e) {
    if (e.target === this.containerTarget && this.mouseDownOnContainerValue === true) {
      this.close(e)
    }
  }

  closeWithKeyboard(e) {
    if (e.keyCode === 27 && !this.containerTarget.classList.contains(this.toggleClass)) {
      this.close(e)
    }
  }

  beforeTurboStreamRender(e) {
    const stream = e.detail.newStream
    const target = document.querySelector(stream.getAttribute('target'))
    const template = stream.querySelector('template')

    // Only consider events that close this modal
    if (target !== this.element && template.innerHTML !== '') {
      return
    }

    enableBodyScroll(this.element)
  }
}
